import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';

const api = axios.create({
  baseURL: process.env.URL_DOMINIO_MICROFWK,
});

export const updateDefaultsESPN = (axiosInstance, properties = {}) => {
  const instance = axiosInstance;
  const props = {};
  _.assign(props, properties);
  _.merge(instance.defaults, props);
  return instance;
};

export const getStartHeaderInfo = params =>
  api
    .get('/services/user/startheaderinfo', { params })
    .then(({ data }) => data);

export const getApaMetadata = params =>
  api.get('/services/apa/metadata', { params }).then(({ data }) => data);

export const getApaAssets = params =>
  api.get('/services/apa/asset', { params }).then(({ data }) => data);

export const postLoginEspn = body =>
  api
    .post('/services/user/idp/espn/authorization', qs.stringify(body), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });

export default api;
